import { memo } from 'react';

import { MessageAvatar } from '@/components/chat/Messages/Message/Avatar';
import { ThinkingIndicator } from '@/components/chat/Messages/ThinkingIndicator';
import { useLayoutMaxWidth } from '@/hooks/useLayoutMaxWidth';
import { cn } from '@/lib/utils';

interface Props {
  assistantName: string;
}

const AssistantThinking = memo(({ assistantName }: Props) => {
  const layoutMaxWidth = useLayoutMaxWidth();

  return (
    <div className="step py-2">
      <div
        className="flex flex-col"
        style={{
          maxWidth: layoutMaxWidth
        }}
      >
        <div
          className={cn(
            'flex flex-grow pb-2',
            'px-2 sm:px-0'
          )}
        >
          <div
            className={cn(
              'ai-message flex w-full',
              'flex-col sm:flex-row sm:gap-4',
              'gap-2 sm:gap-4'
            )}
          >
            <MessageAvatar author={assistantName} isError={false} />
            <div
              className={cn(
                'flex flex-col items-start flex-grow gap-2',
                'w-full sm:min-w-[150px]',
                'mt-1 sm:mt-0'
              )}
            >
              <ThinkingIndicator inline />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

AssistantThinking.displayName = 'AssistantThinking';

export { AssistantThinking };
